module.exports = __webpack_public_path__ + "img/slika17.945707e3.jpg";